<template>
  <FilterProduct v-if="productStore.cards.length > 0"/>
  <div>
    <div class="loading" v-if="!productStore.isLoaded">
      در حال بارگذاری...
    </div>
    <div class="product-inner" v-else-if="productStore.cards.length > 0">
      <ProductCardShablone v-for="product in productStore.cards" :key="product.id" :reaction="false" :card="product" :edit="false" :showOne="false"/>
    </div>
    <div v-else class="none-cart-error">
      سفارشی وجود ندارد
    </div>
    <div ref="el" v-if="productStore.hasMore"></div>
  </div>
</template>
<script setup>
  import { useTemplateRef } from 'vue'
  import { useInfiniteScroll } from '@vueuse/core'
  import { useAlertStore } from '@/stores/alert'
  import { polling } from '@/composables/polling'
  import { isDefrentProductData } from '@/composables/polling/isDefrentProductData'
  import { useProductStore } from '@/stores/product'
  import ProductCardShablone from '@/components/dashboard/bodys/product/card/ProductCardShablone.vue'
  import FilterProduct from './FilterProduct.vue'
  const productStore = useProductStore()
  const alertStore = useAlertStore()
  const el = useTemplateRef('el')
  polling( 
    async () => await productStore.fetchProduct(productStore.cards.length > 0 ? productStore.cards.length : 10 , 0 , false),
    {
      oldData:productStore.cards??[],
      intervalMs: 6000,
      isDifferent: (newData) => isDefrentProductData(productStore.cards,newData),
      onChange: (allNewProduct) => {
        if(isDefrentProductData(productStore.cards??[],allNewProduct??[])){
          if(productStore.cards.length<allNewProduct.length){
            alertStore.type=true
            alertStore.msg='سفارش جدید رسید!'
          }
          productStore.cards = allNewProduct??[]
        }
      }
    }
  )
  useInfiniteScroll(
    el, 
    async () => {
      await productStore.fetchProduct(10,productStore.cards.length,true) 
    } , { 
      distance: 50,
      canLoadMore: () => { 
        return productStore.hasMore
      } 
    }
  )
</script>
<style scoped>
    .product-inner {
        width: 100%;
        direction: rtl;
        height: 100%;
        display: flex;
        flex-direction: row-reverse;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-content: center;
        align-items: stretch;
    }
    .loading,.none-cart-error{
        text-align: center;
        padding: 20px;
        color: white;
        font-size: 20px;
        border-radius: 10px;
        box-shadow: 0 0 10px grey;
        font-weight: bold;
    }
    .loading{
        background: rgb(16, 16, 143);
    }
    .scroll-trigger {
        height: 1px;
    }
    .none-cart-error {
        background: rgb(128, 12, 12);
    }
</style>
